export class VideoQuestionDto {
  id: number;
  videoId: number;
  videoFolderId: number;
  questionId: number;
  questionReference: string;
  questionStatement: string;
  /** Segundo absoluto del video en el que salta la pregunta. */
  second: number;
  /** Obligatoria: no se puede cerrar sin acertar y bloquea el avance del video. */
  restrictive: boolean;
  enabled: boolean;
}
